import React from "react";
import {
  Lock,
  ShieldCheck,
  Server,
  Share2,
  CreditCard,
  Fingerprint,
} from "lucide-react";

function GizlilikPolitikasi() {
  return (
    <div className="max-w-6xl mx-auto p-6 bg-gray-50 min-h-screen">
      {/* Üst Başlık Bölümü */}
      <div className="text-center mb-12">
        <div className="inline-flex items-center justify-center gap-3 mb-6">
          <div className="bg-purple-500 p-3 rounded-full shadow-lg">
            <Lock className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900 uppercase">
            Gizlilik Politikası
          </h1>
        </div>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
          <span className="font-semibold text-gray-900 italic underline decoration-blue-500">
            Ali Zilan ( Classroom)
          </span>{" "}
          olarak, dijital varlıklarınızın ve kişisel bilgilerinizin güvenliğini
          sağlamak en temel önceliğimizdir.
        </p>
      </div>

      <div className="space-y-8">
        {/* Güvenlik Taahhüdü */}
        <div className="bg-purple-500 rounded-3xl p-8 shadow-xl text-white">
          <div className="flex items-center gap-4 mb-4">
            <ShieldCheck className="w-8 h-8 text-white" />
            <h2 className="text-2xl font-bold">Veri Güvenliği Taahhüdü</h2>
          </div>
          <p className="text-blue-50 leading-relaxed text-lg">
            Sistemimiz üzerinde işlenen tüm veriler, modern siber güvenlik
            standartlarına uygun olarak korunmaktadır. Verileriniz sadece hizmet
            kalitesini artırmak ve yasal süreçleri yönetmek adına işlenir.
          </p>
        </div>

        {/* Güvenlik Katmanları Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Parola Güvenliği */}
          <div
            className="bg-white p-6 rounded-3xl shadow-md border border-gray-100 
          hover:shadow-lg transition-shadow"
          >
            <div
              className="bg-purple-500 w-12 h-12 rounded-2xl flex items-center 
            justify-center mb-4"
            >
              <Fingerprint className="text-white w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Parola Güvenliği
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Şifreleriniz geri döndürülemez kriptografik algoritmalarla
              (hashing) saklanır. Şifreniz, veri tabanı yöneticileri dahil hiç
              kimse tarafından görüntülenemez.
            </p>
          </div>

          {/* Kimlik Doğrulama */}
          <div
            className="bg-white p-6 rounded-3xl shadow-md border
           border-gray-100 hover:shadow-lg transition-shadow"
          >
            <div
              className="bg-purple-500 w-12 h-12 rounded-2xl flex 
            items-center justify-center mb-4"
            >
              <Server className="text-white w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Erişim Kontrolü
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Oturum yönetimi endüstri standardı olan{" "}
              <span className="font-mono text-blue-600 bg-blue-50 px-1 rounded">
                JWT (JSON Web Token)
              </span>{" "}
              ile sağlanır. Yetkisiz erişimler otomatik sistemlerle engellenir.
            </p>
          </div>

          {/* İletişim Güvenliği */}
          <div
            className="bg-white p-6 rounded-3xl shadow-md border
           border-gray-100 hover:shadow-lg transition-shadow"
          >
            <div
              className="bg-purple-500 w-12 h-12 rounded-2xl flex 
            items-center justify-center mb-4"
            >
              <ShieldCheck className="text-white w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Uçtan Uca Şifreleme
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Cihazınız ile sunucularımız arasındaki tüm trafik 256-bit{" "}
              <span className="font-semibold text-gray-800">
                SSL/TLS (HTTPS)
              </span>{" "}
              protokolü ile şifrelenerek korunur.
            </p>
          </div>

          {/* Ödeme Güvenliği */}
          <div
            className="bg-white p-6 rounded-3xl shadow-md border
           border-gray-100 hover:shadow-lg transition-shadow"
          >
            <div
              className="bg-purple-500 w-12 h-12 rounded-2xl flex 
            items-center justify-center mb-4 "
            >
              <CreditCard className="text-white w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              PCI-DSS Uyumu
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Ödeme işlemleri doğrudan iyzico altyapısında gerçekleşir. Kredi
              kartı numaranız, CVV kodunuz veya son kullanma tarihiniz
              sistemimize asla kaydedilmez.
            </p>
          </div>
        </div>

        {/* Ticari Gizlilik Notu */}
        <div className="bg-white rounded-3xl p-8 border border-gray-100 shadow-md">
          <div className="flex items-center gap-4 mb-4 text-gray-900">
            <div
              className="bg-purple-500 w-12 h-12 rounded-2xl flex 
            items-center justify-center "
            >
              <Share2 className=" w-6 h-6 text-white" />
            </div>
            <h2 className="text-2xl font-bold">Üçüncü Şahıslarla Paylaşım</h2>
          </div>
          <p className="text-gray-700 leading-relaxed italic">
            "Kullanıcı verileri hiçbir şart altında üçüncü şahıslara veya
            kurumlara ticari bir meta olarak satılmaz. Veri paylaşımı yalnızca
            yasal zorunluluklar ve hizmetin ifası (örneğin iyzico ödeme onayı)
            için gereken minimum düzeyde gerçekleştirilir."
          </p>
        </div>

        {/* İletişim Alt Bölüm */}
        <div className="text-center pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500 italic">
            Gizlilik ilkelerimiz hakkında her türlü soru için{" "}
            <strong>classroom.destek@gmail.com</strong> adresinden bize
            ulaşabilirsiniz.
          </p>
        </div>
      </div>
    </div>
  );
}

export default GizlilikPolitikasi;
